import { Component } from "react";

import "./index.less";

export default class DataLabel extends Component {

  state = {
    loading: false,
  };

  _map = {};

  componentDidMount() {
    this.load();
  };

  load = () => {
    this.props.onLoad().then(data => {
      this._map = data;
      this.setState({
        ...this.state,
        loading: true,
      });
    });
  };

  getLabel = () => {
    const value = this.props.value;
    if (!value) {
      return "";
    }
    const { multiple = false, split = "," } = this.props;
    if (!multiple) {
      const dict = this._map[value];
      return dict ? dict.label : "";
    }
    return value.split(split).map(v => v.trim()).filter(v => v).map(v => {
      const dict = this._map[v];
      return dict ? dict.label : "";
    }).join("，");
  };

  onClick = () => {
    this.props.onClick && this.props.onClick();
  };

  render() {
    if (!this.state.loading) {
      return <></>
    }
    return (
      <span onClick={this.onClick}>
        {this.getLabel()}
      </span>
    );
  }
};
